module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.40162","quantity":0.01402},{"color":"#9dc4b5","label":" 1.40162- 1.40162","quantity":0.01402},{"color":"#e6efc3","label":" 1.40162- 1.58323","quantity":0.01583},{"color":"#ffe89e","label":" 1.58323- 2.06852","quantity":0.02069},{"color":"#f5af7f","label":" 2.06852- 2.97651","quantity":0.02977},{"color":"#ed6d32","label":" 2.97651- 13.88039","quantity":0.1388}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_70_return_10.json
// module id = 7ili
// module chunks = 171